
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 9.833c-.837.02-1.59.494-1.962 1.253l-5.21 10.504c-.03.08-.11.13-.19.14l-11.637 1.682c-.86.12-1.55.707-1.82 1.523s-.05 1.702.57 2.3l8.429 8.173c.06.06.08.15.07.23l-1.99 11.548c-.14.856.2 1.693.9 2.2.39.279.85.428 1.32.428.36 0 .72-.09 1.04-.269L29.927 44.1a.287.287 0 01.072-.025V9.833z"}})])
          )
        }
      }
    